import { render } from "./kalio-founder-profile-card.vue?vue&type=template&id=0c2272f0"
import script from "./kalio-founder-profile-card.vue?vue&type=script&lang=js"
export * from "./kalio-founder-profile-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__